// 사이트 전체에서 <use href="#id"> 로 참조하는 SVG 아이콘 모음 (SiteLayout 에서 한 번만 렌더)
export default function SvgSprite() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
      <symbol id="arr" viewBox="0 0 20 20">
        <path d="M4 10h12M11 5l5 5-5 5" />
      </symbol>
      <symbol id="chev" viewBox="0 0 20 20">
        <path d="M5 8l5 5 5-5" />
      </symbol>
      <symbol id="check" viewBox="0 0 20 20">
        <path d="M4.5 10.5l3.5 3.5 7.5-8" />
      </symbol>
      <symbol id="ccheck" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M6.8 10.2l2.2 2.2 4.2-4.6" />
      </symbol>
      <symbol id="x" viewBox="0 0 20 20">
        <path d="M5 5l10 10M15 5L5 15" />
      </symbol>
      <symbol id="play" viewBox="0 0 20 20">
        <path d="M6 4l10 6-10 6z" />
      </symbol>
      <symbol id="replay" viewBox="0 0 20 20">
        <path d="M4 10a6 6 0 106-6H7M7 1.5L4.5 4 7 6.5" />
      </symbol>
      <symbol id="plus" viewBox="0 0 20 20">
        <path d="M10 4v12M4 10h12" />
      </symbol>
      <symbol id="edit" viewBox="0 0 20 20">
        <path d="M12.5 4.5l3 3L7 16H4v-3z" />
      </symbol>
      <symbol id="more" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M6.5 10h.01M10 10h.01M13.5 10h.01" />
      </symbol>
      <symbol id="msg" viewBox="0 0 20 20">
        <path d="M3 4.5h14v9H8l-4 3v-3H3z" />
      </symbol>
      <symbol id="doc" viewBox="0 0 20 20">
        <path d="M5 2.5h7l3.5 3.5v11.5H5zM12 2.5V6h3.5M7.5 10h5M7.5 13h5" />
      </symbol>
      <symbol id="search" viewBox="0 0 20 20">
        <circle cx="9" cy="9" r="5.5" />
        <path d="M13 13l4 4" />
      </symbol>
      <symbol id="spark" viewBox="0 0 20 20">
        <path d="M10 2.5l1.8 5.7 5.7 1.8-5.7 1.8-1.8 5.7-1.8-5.7-5.7-1.8 5.7-1.8z" />
      </symbol>
      <symbol id="send" viewBox="0 0 20 20">
        <path d="M17.5 2.5l-15 6 6 2.5 2.5 6zM8.5 11l9-8.5" />
      </symbol>
      <symbol id="up" viewBox="0 0 20 20">
        <path d="M10 16V4M5 9l5-5 5 5" />
      </symbol>
      <symbol id="clock" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M10 6v4l2.5 2" />
      </symbol>
      <symbol id="db" viewBox="0 0 20 20">
        <ellipse cx="10" cy="5" rx="6.5" ry="2.5" />
        <path d="M3.5 5v10c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5V5M3.5 10c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5" />
      </symbol>
      <symbol id="branch" viewBox="0 0 20 20">
        <circle cx="5" cy="4.5" r="2" />
        <circle cx="5" cy="15.5" r="2" />
        <circle cx="15" cy="8" r="2" />
        <path d="M5 6.5v7M15 10c0 3-4 3-8.5 4" />
      </symbol>
      <symbol id="folder" viewBox="0 0 20 20">
        <path d="M2.5 5.5a1 1 0 011-1h4l1.5 2h7.5a1 1 0 011 1v8a1 1 0 01-1 1h-13a1 1 0 01-1-1z" />
      </symbol>
      <symbol id="server" viewBox="0 0 20 20">
        <rect x="3" y="3.5" width="14" height="5" rx="1" />
        <rect x="3" y="11.5" width="14" height="5" rx="1" />
        <path d="M6 6h.01M6 14h.01" />
      </symbol>
      <symbol id="hash" viewBox="0 0 20 20">
        <path d="M7.5 3l-1.5 14M14 3l-1.5 14M3.5 7.5h13M3 12.5h13" />
      </symbol>
      <symbol id="mail" viewBox="0 0 20 20">
        <rect x="2.5" y="4.5" width="15" height="11" rx="1.5" />
        <path d="M3 5.5l7 5.5 7-5.5" />
      </symbol>
      <symbol id="globe" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M2.5 10h15M10 2.5c2.2 2.3 2.2 12.7 0 15M10 2.5c-2.2 2.3-2.2 12.7 0 15" />
      </symbol>
      <symbol id="book" viewBox="0 0 20 20">
        <path d="M3 4h5a2 2 0 012 2v10a2 2 0 00-2-2H3zM17 4h-5a2 2 0 00-2 2v10a2 2 0 012-2h5z" />
      </symbol>
      <symbol id="cpu" viewBox="0 0 20 20">
        <rect x="5" y="5" width="10" height="10" rx="1.5" />
        <path d="M8 2v3M12 2v3M8 15v3M12 15v3M2 8h3M2 12h3M15 8h3M15 12h3" />
      </symbol>
      <symbol id="layers" viewBox="0 0 20 20">
        <path d="M10 3l7.5 4-7.5 4-7.5-4zM2.5 11l7.5 4 7.5-4" />
      </symbol>
      <symbol id="repeat" viewBox="0 0 20 20">
        <path d="M4 8a6 6 0 0110.5-3.5L16 6M16 3v3h-3M16 12a6 6 0 01-10.5 3.5L4 14M4 17v-3h3" />
      </symbol>
      <symbol id="users" viewBox="0 0 20 20">
        <circle cx="7.5" cy="7" r="3" />
        <path d="M2 16.5c.6-2.8 2.8-4.5 5.5-4.5s4.9 1.7 5.5 4.5M13 4.2a3 3 0 010 5.6M15 12.3c1.6.6 2.7 2.1 3 4.2" />
      </symbol>
      <symbol id="shield" viewBox="0 0 20 20">
        <path d="M10 2.5l6 2.5v4.5c0 4-2.6 6.8-6 8-3.4-1.2-6-4-6-8V5z" />
        <path d="M7.5 10l2 2 3.5-3.5" />
      </symbol>
      <symbol id="quote" viewBox="0 0 20 20">
        <path d="M4 4.5h12v8.5H9l-4 3v-3H4zM7.5 8h5M7.5 10.5h3" />
      </symbol>
      <symbol id="chart" viewBox="0 0 20 20">
        <path d="M3 16.5h14M5.5 13.5v-4M10 13.5V5.5M14.5 13.5v-6" />
      </symbol>
      <symbol id="grid" viewBox="0 0 20 20">
        <rect x="3" y="3" width="5.5" height="5.5" rx="1" />
        <rect x="11.5" y="3" width="5.5" height="5.5" rx="1" />
        <rect x="3" y="11.5" width="5.5" height="5.5" rx="1" />
        <rect x="11.5" y="11.5" width="5.5" height="5.5" rx="1" />
      </symbol>
      <symbol id="info" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M10 9v5M10 6.5h.01" />
      </symbol>
      <symbol id="ptr" viewBox="0 0 22 22">
        <path d="M4 2.5l13 8-5.8 1.4L8.7 18z" />
      </symbol>
      <symbol id="minus" viewBox="0 0 20 20">
        <path d="M4 10h12" />
      </symbol>
      <symbol id="link" viewBox="0 0 20 20">
        <path d="M8.5 11.5a3.5 3.5 0 005 0l2.5-2.5a3.5 3.5 0 00-5-5l-1 1M11.5 8.5a3.5 3.5 0 00-5 0L4 11a3.5 3.5 0 005 5l1-1" />
      </symbol>
      <symbol id="filter" viewBox="0 0 20 20">
        <path d="M3 4h14l-5.5 6.5V16l-3 1.5v-7z" />
      </symbol>
      <symbol id="cube" viewBox="0 0 20 20">
        <path d="M10 2.5l6.5 3.5v8L10 17.5 3.5 14V6zM3.5 6L10 9.5 16.5 6M10 9.5v8" />
      </symbol>
      <symbol id="flag" viewBox="0 0 20 20">
        <path d="M5 17.5V3M5 3.5h9l-2 3.5 2 3.5H5" />
      </symbol>
      <symbol id="save" viewBox="0 0 20 20">
        <path d="M4 3.5h9.5L16.5 6.5V16.5H4zM7 3.5v4h6v-4M7 16.5v-5h6v5" />
      </symbol>
      <symbol id="hand" viewBox="0 0 20 20">
        <path d="M7 10V4.5a1.3 1.3 0 012.6 0V9M9.6 8.5V3.5a1.3 1.3 0 012.6 0V9M12.2 8.5V5a1.3 1.3 0 012.6 0v6c0 3.5-2.2 6-5.4 6-2.3 0-3.6-1-4.9-3L3 10.8a1.3 1.3 0 012-1.6L7 11" />
      </symbol>
      <symbol id="store" viewBox="0 0 20 20">
        <path d="M3 8l1.5-4.5h11L17 8M3 8h14M3 8c0 1.4 1 2.5 2.3 2.5S7.7 9.4 7.7 8c0 1.4 1 2.5 2.3 2.5s2.3-1.1 2.3-2.5c0 1.4 1 2.5 2.4 2.5S17 9.4 17 8M4.5 10.5v6h11v-6" />
      </symbol>
      <symbol id="copy" viewBox="0 0 20 20">
        <rect x="6.5" y="6.5" width="10" height="10" rx="2" />
        <path d="M13.5 6.5V4.5a1 1 0 00-1-1h-8a1 1 0 00-1 1v8a1 1 0 001 1h2" />
      </symbol>
      <symbol id="plug" viewBox="0 0 20 20">
        <path d="M7 2.5v4M13 2.5v4M5 6.5h10v3a5 5 0 01-10 0zM10 14.5v3" />
      </symbol>
      <symbol id="building" viewBox="0 0 20 20">
        <path d="M3.5 17.5V3.5h8v14M11.5 7.5h5v10M2 17.5h16M6 6.5h3M6 9.5h3M6 12.5h3M14 10.5h.01M14 13.5h.01" />
      </symbol>
      <symbol id="history" viewBox="0 0 20 20">
        <path d="M3 10a7 7 0 107-7 7 7 0 00-5.3 2.4M3 3v3.5h3.5M10 6.5V10l2.5 1.5" />
      </symbol>
      <symbol id="star" viewBox="0 0 20 20">
        <path d="M10 2.8l2.2 4.6 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L2.8 8.1l5-.7z" />
      </symbol>
      <symbol id="upload" viewBox="0 0 20 20">
        <path d="M10 13V3.5M6 7l4-4 4 4M3.5 13v3.5h13V13" />
      </symbol>
      <symbol id="cut" viewBox="0 0 20 20">
        <rect x="3" y="3" width="14" height="4" rx="1" />
        <rect x="3" y="9" width="9" height="4" rx="1" />
        <rect x="3" y="15" width="11" height="2.5" rx="1" />
      </symbol>
      <symbol id="alert" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M10 6v5M10 13.5h.01" />
      </symbol>
      <symbol id="coin" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M12.5 7.5c-.4-.9-1.4-1.5-2.5-1.5-1.4 0-2.5.8-2.5 2s1.1 1.6 2.5 2 2.5.8 2.5 2-1.1 2-2.5 2c-1.1 0-2.1-.6-2.5-1.5M10 4.5V6M10 14v1.5" />
      </symbol>
        <symbol id="building" viewBox="0 0 20 20">
          <path d="M3.5 17.5V3.5h8v14M11.5 7.5h5v10M2 17.5h16M6 6.5h3M6 9.5h3M6 12.5h3" />
        </symbol>
      </defs>
    </svg>
  );
}
